<article *ngIf="data">
    <div class="container">
        <div class="row">
            <div class="image-wrapper">
                <ng-container *ngIf="data.image && data.image.src">
                    <app-image
                        [image]="data.image"
                        [width]="1568"
                        [index]="data.spotIndex"
                        [height]="520"
                        [style]="{ objectFit: 'cover', height: '100%' }"
                        [intersectionOptions]="{ threshold: 0 }"
                        crop="crop"
                    ></app-image>
                </ng-container>
            </div>
            <div
                class="col-12 col-md-6 col-lg-5 col-xl-4"
                [ngClass]="{ 'offset-md-6 offset-lg-7 offset-xl-8': data.alignment === alignment.Right }"
            >
                <div appParallaxElement [travel]="40" [dullness]="10">
                    <div class="content-wrapper">
                        <div
                            class="content"
                            [ngClass]="{ white: data.textColor === textColor.White }"
                            [style.background-color]="'#' + data.backgroundColorPicker || 'f1f1f1'"
                        >
                            <div class="logo-wrapper" *ngIf="data.imageOrLogo && data.imageOrLogo.src">
                                <app-image
                                    [image]="data.imageOrLogo"
                                    [width]="100"
                                    crop="min"
                                    format="none"
                                ></app-image>
                            </div>
                            <app-spot-headline *ngIf="data.headlineText" [index]="data.spotIndex" section="h1">
                                {{ data.headlineText }}
                            </app-spot-headline>
                            <div
                                *ngIf="data.richText"
                                class="kk-rte"
                                appInterceptLinks
                                [innerHTML]="data.richText | safe: 'html'"
                            ></div>
                            <div class="link" *ngIf="data.link as link">
                                <app-link [link]="link">
                                    <span class="kk-btn d-inline-block">{{ link.name }}</span>
                                </app-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</article>
